export default {
  SHOW_DIALOG: '@WS/DIALOG/SHOW_DIALOG',
  HIDE_DIALOG: '@WS/DIALOG/HIDE_DIALOG',
};
